import { createQueryKeys } from "@lukemorales/query-key-factory";
import { PeriodicReportListFilterPayload } from "./periodicReports.types";

/**
 * Keys used to invalidate stored cached data regarding periodic report module
 */
export const periodicReportKeys = createQueryKeys("periodic_report", {
  periodicReportList: ({
    filters,
  }: {
    filters?: PeriodicReportListFilterPayload;
  }) => ({
    queryKey: ["list", filters],
  }),
});
